import { toggleHasAttachments } from '../actions/internalActions';
import { SearchScenarioId, startSearch } from 'owa-search';

export default function onHasAttachmentsFilterClicked() {
    toggleHasAttachments();
    startSearch('InteractiveFilter', SearchScenarioId.Mail, false /* explicitSearch */);
}
